import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { HistoryOutlined } from "@mui/icons-material";

import { useTicketDetailContext } from "contexts/TicketDetailContext";

import HistoryTimeline from "components/Shared/HistoryTimeline";

const TicketHistoryTab = () => {
  const { ticketDetail } = useTicketDetailContext();

  const sortedTicketHistory =
    [...ticketDetail?.history]?.sort((a, b) =>
      a?.createdAt > b?.createdAt ? -1 : 1
    ) ?? [];

  return (
    <>
      <Box display="flex" justifyContent="space-between" padding={3}>
        <Box display="inline-flex" alignItems="center" gap={1.5}>
          <HistoryOutlined style={{ color: "gray" }} />

          <Typography style={{ fontWeight: 500 }}>History</Typography>
        </Box>
      </Box>

      <Divider />

      <br />

      <HistoryTimeline timelineItems={sortedTicketHistory} />
    </>
  );
};

export default TicketHistoryTab;
